<template>
    <div>
        <div class="mt-30"> 
            <div class="nees_middel">
                <p>{{needsObj.title}}</p>
                <p>
                    <span>发布时间 :</span>
                    <span>{{needsObj.createDate}}</span>
                </p>
               
            </div>    
            <div class="nees_box mt-20">
                    <p>
                        <span>需求开始时间 :</span>
                        <span class="ml-10">{{needsObj.beginDate}}</span>
                    </p>
                     <p class="ml-30">
                        <span>需求类别 :</span>
                        <span class="ml-10">{{cate}}</span>
                    </p>      
            </div>
            <div class="nees_box mt-10">
                   <p class="">
                        <span>需求结束时间 :</span>
                        <span class="ml-10">{{needsObj.endDate}}</span>
                    </p>
                    <p class="ml-30">
                        <span>需求状态 :</span>
                        <span class="ml-10">{{needsObj.status ==1?'待审核':needsObj.status ==2?'审核不通过':needsObj.status ==3?'未解决':needsObj.status ==4?'已解决':needsObj.status ==5?'已关闭':''}}</span>
                    </p>
            </div>
            <div class="nees_text" v-html="needsObj.content"> 
            </div>
            <div class="nees_foot">
                <!-- <img  src="../assets/images/course.jpg" alt="">
                <img  src="../assets/images/course.jpg" alt=""> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
      needsObj:{
        type:Object
      }
    },
    data(){
       return{
           cate:''
       }
    },
    methods:{
     getCate(id) {
        return this.$store.getters.itemIndutry(id);
     }
    },
    watch:{
      needsObj(val){
        this.cate = this.getCate(val.type)
      }  
    }
}
</script>
<style scoped>
.nees_middel{
  display: flex;
  justify-content: space-between;
  /* align-items: center; */
}
.nees_middel p:nth-child(1){
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #080707;
    width: 73%;
    text-align: left;
}
.nees_middel p:nth-child(2){
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
}
.nees_box{
    display: flex;
    justify-content: flex-start;   
    text-align: left;
}
.nees_box p span{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
}
.nees_text{
    margin-top: 20px;
    line-height: 24px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    text-align: left;
}
.nees_text >>>p span {
    background-color: #fff !important;
}
.nees_foot{
    margin-top: 20px;
    text-align: left;
}
.nees_foot img{
    width: 215px;
    height: 161px;
    margin-right: 20px;
}
.ml-10{
    margin-left: 10px;
}
.ml-30{
    margin-left: 30px;
}
.mt-10{
    margin-top: 10px;
}
.mt-20{
    margin-top: 20px;
}
.nees_text>>>table{
    text-align: center;
   border-collapse: collapse;
}
.nees_text >>>table tr td { 
    border:1px solid #EDEDED; 
}
</style>


// WEBPACK FOOTER //
// src/components/needsDetail.vue